module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/4-1e41fcab7645bbe958abf59dadbaba1c.webp";